import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';
import { BatchDownloadFileFilters, BatchDownloadFileManagment } from './types';

export const validationBatchDownloadFile = yup
  .object()
  .shape({
    batchName: yup.object().nullable().notRequired(),
    batchDescription: yup.object().nullable().notRequired(),
  })
  .test('batch-name-or-batch-description-required', 'Campo obbligatorio', (values) => {
    const formValues = values as unknown as BatchDownloadFileFilters;
    if (formValues?.batchName || formValues?.batchDescription) {
      return true;
    }

    return new yup.ValidationError('Campo obbligatorio', undefined, 'batchName');
  });

export const headCells: HeadCell<BatchDownloadFileManagment, keyof BatchDownloadFileManagment>[] = [
  {
    id: 'code',
    label: 'Nome File',
    colSpan: 4,
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'updateDate',
    label: 'Data Aggiornamento',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
